<template><div><h1 id="adressliste-nach-umsatztyp-response-und-zeitraum" tabindex="-1"><a class="header-anchor" href="#adressliste-nach-umsatztyp-response-und-zeitraum"><span>Adressliste nach Umsatztyp, Response und Zeitraum</span></a></h1>
<p>Adressliste nach Umsatztyp, Response und Zeitraum — Erstellt eine Adressliste mit Response inkl. Datum und dem Umsatztotal im Format Excel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Das Ergebnis dieser Auswertung ist eine Adressliste mit allen Responses mit Wert und Datum (kommagetrennt) und zusätzlich dem kumuliertem Totalbetrag aller Responses. Es werden nur Responses berücksichtigt, die sich auf den gewählten Zeitraum, dem Umsatzbetrag und dem Umsatztyp entsprechen. Das Ausgabeformat ist eine Excelliste.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Adressliste nach Umsatztyp, Response und Zeitraum</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Datum von/bis</dt>
<dd>Datumsbereich für die Auswertung.</dd>
<dt>Filter</dt>
<dd>Einschränkung nach Filter.</dd>
<dt>Ereignisse</dt>
<dd>Einschränkung nach Ereignissen.</dd>
<dt>Umsatz von/bis</dt>
<dd>Einschränkung nach Umsatzbetrag.</dd>
<dt>UmsatzTyp</dt>
<dd>Einschränkung nach Umsatztyp.</dd>
<dt>Export</dt>
<dd>Einschränkung der zu exportierenden Daten nach &quot;nur Personen mit Umsatz&quot; oder &quot;alle Personen&quot; (keine Einschränkung).</dd>
<dt>Sortierung</dt>
<dd>Sortierung der exportierten Liste nach &quot;Personen-ID&quot;, &quot;PLZ&quot; oder &quot;Ort&quot;.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet nebst der Rekapitulation der Eingabeparameter die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Personen-ID</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name und Adresse</td>
<td>Personendaten einzeilig (Organisation, Vorname, Name, Strasse, PLZ, Ort)</td>
</tr>
<tr>
<td>Umsatz</td>
<td>Totalbetrag aller Responses</td>
</tr>
<tr>
<td>Response</td>
<td>Anzahl Responses</td>
</tr>
<tr>
<td>ohne Label</td>
<td>Alle Responses kommagetrennt mit Datum in Klammer</td>
</tr>
</tbody>
</table>
</div></template>


